
import React, { ChangeEventHandler, FC } from "react";
import { ToggleButton } from "react-bootstrap";

export interface ToggleButtonProps {
  name: string;
  checked: boolean;
  onChange: ChangeEventHandler;
}


const ToggleButtonComponent: FC<ToggleButtonProps> = ({
    name,
    checked = false,
    onChange,
  }) => {
      return(

        <ToggleButton
            key={name}
            id={`radio-${name}`}
            type="radio"
            variant={"outline-dark"}
            name="radio"
            value={name}
            checked={checked}
            onChange={onChange}
            className="theam-font"
          >
            {name}
          </ToggleButton>
      );
  }


  export default ToggleButtonComponent;